const buttonGroupContextKey = Symbol("buttonGroupContextKey");

export { buttonGroupContextKey };
//# sourceMappingURL=constants.mjs.map
